import { api } from '@/shared/api/axios';
import type { CreateTaskPayload, Task, TasksFilters, UpdateTaskPayload } from '@/features/tasks/types';
import type { MutationResponse } from './contracts';
import { taskPaths } from './paths';

export const tasksApi = {
  async list(filters: TasksFilters = {}): Promise<Task[]> {
    const { data } = await api.get<{ tasks: Task[] }>(taskPaths.list(filters));
    return data.tasks ?? [];
  },
  async mine(): Promise<Task[]> {
    const { data } = await api.get<{ tasks: Task[] }>(taskPaths.mine);
    return data.tasks ?? [];
  },
  async detail(id: string): Promise<Task> {
    return (await api.get<{ task: Task }>(taskPaths.detail(id))).data.task;
  },
  async create(payload: CreateTaskPayload): Promise<MutationResponse & { id: string }> {
    return (await api.post<MutationResponse & { id: string }>(taskPaths.create, payload)).data;
  },
  async update(id: string, payload: UpdateTaskPayload): Promise<MutationResponse> {
    return (await api.patch<MutationResponse>(taskPaths.update(id), payload)).data;
  },
  async remove(id: string): Promise<MutationResponse> {
    return (await api.delete<MutationResponse>(taskPaths.remove(id))).data;
  },
};
